export const promiseWithTimeout = (promise, timeout, timeOutError = new Error('Promise timed out')) => {
    const timeOut = new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(timeOutError);
        }, timeout);
    });
    return Promise.race([promise, timeOut]);
};
